import { get, post, put, del } from './api';

// Create a new bbrand
export const createBrand = (data) => {
  return post('/brands', data);
};


export const getAllBrands = (
  page = 1,
  limit = 10,
  search = '',
  sortField = 'id',
  sortOrder = 'desc'
) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', limit);
  if (search) params.append('name', search);
  if (sortField) params.append('sort_field', sortField);
  if (sortOrder) params.append('sort_order', sortOrder);

  return get(`/brands?${params.toString()}`);
};

//  Get all brands as list (no pagination)
export const getAllBrandLists = () => {
  return get('/brands/list');
};

// Get a brands by ID
export const getBrandById = (id) => {
  return get(`/brands/${id}`);
};

// Update a brands
export const updateBrand = (id, data) => {
  return put(`/brands/${id}`, data);
};

// Delete a brands (soft delete if your backend supports it)
export const deleteBrand = (id) => {
  return del(`/brands/${id}`);
};
